/**
 * Getters for add new
 */
export const getters = {
  getName(state) {
    return {
      firstName: state.firstName,
      lastName: state.lastName
    };
  },
  getAddress(state) {
    return {
      pha_line1: state.pha_line1,
      pha_line2: state.pha_line2,
      pha_city: state.pha_city,
      pha_state: state.pha_state,
      pha_postalCode: state.pha_postalCode
    };
  },
  getBirthDate(state) {
    return state.birthDate;
  },
  getPhoneType(state) {
    return state.phoneType;
  },
  getAllPhoneTypes(state) {
    return state.allPhoneTypes;
  },
  getPhone(state) {
    return state.phone;
  },
  getEmail(state) {
    return state.email;
  },
  getLoading(state) {
    return state.loading;
  },
  getTimezones(state) {
    return state.timezone.list;
  },
  getSelectedTimezone(state) {
    return state.timezone.selected;
  },
  getFormSubmitted(state) {
    return state.submitted;
  },
  getInsuranceCompanies(state) {
    return state.insuranceCompanies;
  },
  getSelectedInsuranceValue(state) {
    return state.selectedInsuranceValue;
  },
  getInsuranceType(state) {
    return state.insuranceType;
  },
  getInsuranceId(state) {
    return state.insuranceId;
  },
  getStateCodes(state) {
    return state.stateCodes;
  },
  getNotes(state) {
    return state.notes;
  }
};
